export default __webpack_public_path__ + "static/media/Exclusive Luggage Deals_0511_0312_2025.8b29afc9.xlsx";